// extracted by mini-css-extract-plugin
module.exports = {"ErrorScreen":"ErrorScreen_ErrorScreen__i64uE"};